import { useHistory } from "react-router-dom";
import image from "../Media/404.svg";
import { useTranslation } from "react-i18next";
import styles from "./NotFoundPage.module.scss";
import { Button, Col, Row } from "antd";
import CustomButton from "../CustomComponents/CustomButton";
import { theme } from "../theme";

const NotFoundPage = () => {
	const { t } = useTranslation();
	const history = useHistory();

	const handleClick = () => history.push("/");

	return (
		<div className={styles.wrapper}>
			<Row>
				<Col
					span={window.innerWidth > 1215 ? 11 : 24}
					style={{ display: "flex", justifyContent: "center" }}
				>
					<div className={styles.container}>
						<h1>Pagina căutata nu a fost gasită sau nu ai permisiuni pentru a o accesa!</h1>
						<CustomButton
							backgroundcolor={theme.primaryColor}
							textcolor={theme.white}
							fontSize={"1rem"}
							paddingvertical={"1.2rem"}
							paddinghorizontal={"1.4rem"}
            				onClick={handleClick}>
							{t("header.home")}
						</CustomButton>
					</div>
				</Col>
				<Col
					span={window.innerWidth > 1215 ? 11 : 24}
					style={{ display: "flex" }}
				>
					<div>
						<img
							alt={"img2"}
							src={image}
							style={{
								width: window.innerWidth > 1215 ? "40rem" : "20rem",
								height: window.innerWidth > 1215 ? "40rem" : "20rem",
							}}
						/>
					</div>
				</Col>
			</Row>
		</div>
	);
};
export default NotFoundPage;
